export default {
  aws: {},
  gcp: {},
  types: {
    frequentValue: '1',
    frequentUnit: 'TB',
    infrequentValue: '1',
    infrequentUnit: 'TB',
    archiveValue: '1',
    archiveUnit: 'TB',
  },
  view: {
    chartsStacked: false,
    tabsIndex: 0,
  },
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js